import { useState } from "react";

// "Start a new goal" switch in the habit edit form, under the number the habit
// is counted by. On = the changed number becomes a new goal from the next
// period and past weeks keep the old one; Off = the edit is a correction and
// the new number applies to the whole history. The (i) opens a small badge
// (fades in) that says what the switch is for. `info` is the badge text.
// While on, two "Starts" chips pick today or the next period (`nextLabel`,
// "yyyy-mm-dd"; the default), with a one-line `preview` of the result.
export function GoalNewToggle({ on, onChange, info, now, onNow, nextLabel, preview }) {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button type="button" onClick={() => setShowInfo(v => !v)} aria-label="What is this?" aria-expanded={showInfo}
          style={{ flexShrink: 0, minWidth: 0, minHeight: 0, width: 20, height: 20, borderRadius: "50%", padding: 0, cursor: "pointer",
            border: "1.5px solid var(--c-text-soft)", background: "transparent", color: "var(--c-text-soft)",
            fontSize: 11, fontWeight: 800, fontStyle: "italic", fontFamily: "serif", lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>i</button>
        <span style={{ flex: 1, fontSize: 12, fontWeight: 700, color: "var(--c-text)" }}>Start a new goal</span>
        <button type="button" role="switch" aria-checked={on} aria-label="Start a new goal" onClick={() => onChange(!on)}
          style={{ flexShrink: 0, minWidth: 0, minHeight: 0, width: 38, height: 22, borderRadius: 999, border: "none", cursor: "pointer", padding: 0, position: "relative",
            background: on ? "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))" : "var(--c-border)", transition: "background 0.2s" }}>
          <span style={{ position: "absolute", top: 2, left: on ? 18 : 2, width: 18, height: 18, borderRadius: "50%", background: "var(--c-bg-card)", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", transition: "left 0.2s cubic-bezier(0.34,1.56,0.64,1)" }} />
        </button>
      </div>
      {on && (
        <div style={{ marginTop: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: "var(--c-text-mid)" }}>Starts:</span>
            {[[true, "Today"], [false, nextLabel ? new Date(nextLabel + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "Next week"]].map(([val, label]) => {
              const sel = !!now === val;
              return (
                <button key={label} type="button" aria-pressed={sel} onClick={() => onNow(val)}
                  style={{ minWidth: 0, minHeight: 0, padding: "5px 12px", borderRadius: 999, cursor: "pointer", fontSize: 11.5, fontWeight: sel ? 700 : 600,
                    border: sel ? "1.5px solid var(--c-primary)" : "1px solid var(--c-border)",
                    background: sel ? "color-mix(in srgb, var(--c-primary) 22%, transparent)" : "var(--c-bg-card)", color: sel ? "var(--c-text-accent)" : "var(--c-text-mid)" }}>{label}</button>
              );
            })}
          </div>
          {preview && <p style={{ margin: "6px 0 0", fontSize: 11, lineHeight: 1.4, color: "var(--c-text-mid)", fontWeight: 600 }}>{preview}</p>}
        </div>
      )}
      {showInfo && (
        <div className="clarity-fade" role="note"
          style={{ marginTop: 8, padding: "8px 10px", borderRadius: 10, background: "var(--c-bg-active)", border: "1px solid var(--c-border)", fontSize: 11, lineHeight: 1.45, color: "var(--c-text-mid)", fontWeight: 600, whiteSpace: "pre-line" }}>
          {info}
        </div>
      )}
    </div>
  );
}
